import React, { useCallback } from 'react';
import { useObservable } from 'react-use-observable';

import { Button, Typography } from 'antd';

import ordersService from 'v2/services/orders';

import { Icon } from '@eduzz/ui-antd-theme';

const LabelGenerator = () => {
  const [isLoading] = useObservable(() => ordersService.isLoading(), []);
  const [orders] = useObservable(() => ordersService.getOrders(), []);

  const onUnCheckAll = useCallback(() => ordersService.unCheckAllOrders(), []);

  const onGenerateLabels = useCallback(() => ordersService.generateLabel(), []);

  const ordersChecked = (orders || []).filter(o => o.checked);

  const qtOrderChecked = ordersChecked.length;

  if (isLoading || qtOrderChecked < 1) {
    return null;
  }

  return (
    <div
      className='sticky top-16 z-(--uizz-antd-z-index-base) mb-4 flex w-full flex-wrap items-center justify-between gap-3 rounded-md bg-(--uizz-antd-color-bg-container) p-4 shadow-sm'
      id='label-generator'
    >
      <Typography.Text strong>{qtOrderChecked} selecionado(s)</Typography.Text>
      <div className='flex flex-wrap justify-end gap-2'>
        <Button onClick={onUnCheckAll}>Cancelar</Button>
        <Button type='primary' icon={<Icon.Tag />} onClick={onGenerateLabels}>
          Gerar etiquetas
        </Button>
      </div>
    </div>
  );
};

export default LabelGenerator;
